<script>
  import Footer from "./Footer.svelte";

  let props = $props();
  let { children } = props;
</script>

<div class="min-h-screen bg-white">
  {@render children()}

  <Footer />
</div>
